import { InputBoxSingle } from '@peacecover/component';

type GradientBodyBoxProps = {
  title: string;
  description?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  showWarningText?: boolean;
  warningText?: string;
} & React.ComponentProps<typeof InputBoxSingle>;

const GradientBodyBox = ({
  title,
  description,
  placeholder,
  value,
  onChange,
  className,
  showWarningText,
  warningText,
  ...props
}: GradientBodyBoxProps) => {
  return (
    <div className={`relative rounded-[18px] p-[2px] ${className}`}>
      <div className="absolute inset-0 rounded-[18px] bg-[linear-gradient(136deg,#15CCCB_1.21%,#4987FF_50.69%,#8B1CFA_101.7%)]" />
      <div className="flex flex-col relative rounded-[16px] bg-background-light dark:bg-background-dark px-[20px] py-[24px]">
        <div className="flex flex-col gap-[8px] text-center mb-[20px]">
          <p className="text-[17px] leading-[20px] font-bold text-text-main-lv2">{title}</p>
          {description && (
            <p className="text-[13px] leading-[16px] text-text-main-lv3">{description}</p>
          )}
        </div>
        <InputBoxSingle
          className="bg-transparent border-none"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...props}
        />
        {showWarningText && warningText && (
          <p className="text-[13px] font-medium leading-[16px] text-on-warning mt-[8px]">
            {warningText}
          </p>
        )}
      </div>
    </div>
  );
};

export default GradientBodyBox;
